// 计费单

import { HttpGetInventoryTask, HttpGetInventoryTaskExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryTask,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }

        },
        interceptRequest(params) {
            params.state = this.isAdmin() ? '1' : '0';
            this.formData.state = params.state;
            return params

        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryTaskExport, this.formData, 'download').then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
        getInfoMap(params = "") {
            //大于-1 是存在
            return [13, 40, 70, 100,104,110,122, 116, 21, 126].indexOf(params) > -1;
        },
        isAdmin() {
            return this.$route.name === 'inventorySerTask';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getBillcusorgList','getSelfmanageorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse','getBillcusWareList','getManageAccountList','getOrgAccountList']),
        // ...mapGetters('common', ['getInventoryType', 'getInventoryTaskOpType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.inventorytask.export'),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).map(function (item = "") {
                        return { value: item.attach.code, label: item.label };
                    }),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('bi.work.task_account_id', { defaultValue: "渠道" }),
                    key: 'IN_sourceChannel',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getManageAccountList : this.getOrgAccountList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_groupCode',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.action_order', { defaultValue: "执行单号" }),
                    key: 'EQ_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.plan_order', { defaultValue: "计划单号" }),
                    key: 'CN_planNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'CN_orderNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.alloment.order_type', { defaultValue: "单据类型" }),
                    key: 'EQ_opType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryTaskOpType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inventory.stock_change_type', { defaultValue: '库存变动类型' }),
                    key: 'EQ_opLabel',
                    more: true,
                    tag: 'vSelect',
                    options: [
                        {value:2,label:this.$t('fbb.inventory.inbound', { defaultValue: '入库' })},
                        {value:3,label:this.$t('erp.channelbase.outbound', { defaultValue: '出库' })},
                    ],
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    default: this.handleDateRange().join(' ~ '),
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdmin() ? this.getCusproductList : this.getProductList,
                            row.groupCode
                        )
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    key: 'sourceChannel',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.action_order', { defaultValue: '执行单号' }),
                    key: 'sourceNo',
                },
                {
                    title: this.$t('fbb.inventory.plan_order', { defaultValue: '计划单号' }),
                    key: 'planNo',
                    render:(h, {row})=>{
                        let planNo = row.opType == 100 ? row.planNo.split('-')[0] : row.planNo
                        return <div>{planNo}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'orderNo',
                },
                {
                    title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let opType = row.opType
                        const { label } = this.getInventoryTaskOpType.find(function (item) {
                            return item.value == opType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.stock_change_type', { defaultValue: '库存变动类型' }),
                    maxWidth: 60,
                    render: (h, { row }) => {
                        if (this.getInfoMap(row.opType)) {
                            return this.$t('erp.channelbase.outbound', { defaultValue: '出库' });
                        } else {
                            return this.$t('fbb.inventory.inbound', { defaultValue: '入库' });
                        }
                    }
                },
                {
                    title: this.$t('fbb.inventory.change_number', { defaultValue: '变动数量' }),
                    key: 'quantity',
                    maxWidth: 60,
                    render: (h, { row }) => {
                        if (this.getInfoMap(row.opType)) {
                            return -row.quantity;
                        } else {
                            return row.quantity;
                        }
                    }
                },
                // {
                //     title: this.$t('fbb.inventory.product_value', { defaultValue: '产品价值' }),
                //     key: 'fobCost',
                // },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }

                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }


                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




